import TagList from './tag-list'

export default TagList
